import React, { Component } from 'react';

import IconButton from '@material-ui/core/IconButton';
import ArrowDropUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown';
export const FAQs = function (props) {
    return (
        <div>
            <Panel header="¿Cómo realizo mi pedido?">
                <>
                    ¡Es muy sencillo! Puedes llamar a nuestra tienda al 971 743 750, de 9:30h a 13h y de 16:30h a 19h, o hacerlo a través de la web:{' '}
                    <a href="https://www.canapaulina.es/pedidosonline/">https://www.canapaulina.es/pedidosonline/</a>
                </>
            </Panel>
            <Panel header="¿Cómo sé si Ca Na Paulina reparte en mi zona?">
                <>
                    Repartimos en varios puntos de Mallorca. Introduce tu código postal en el siguiente enlace, y comprueba si llegamos hasta tu casa:{' '}
                    <a href="https://www.canapaulina.es/pedidosonline/">https://www.canapaulina.es/pedidosonline/</a> <br />
                </>
            </Panel>
            <Panel header="¿Qué pasa si no tengo número de fidelización?">
                <>Son aproximados, ya que los pesos pueden variar.</>
            </Panel>
            <Panel header="¿Puedo modificar mi pedido una vez confirmado?">
                <>¡Claro! Llama a la tienda (971 743 750) y facilítanos el número de pedido. Indícanos las modificaciones pertinentes, ¡y listo!</>
            </Panel>
            <Panel header="¿Qué hago si mi pedido ha llegado mal?">
                <>Lo lamentamos… Ponte en contacto con nosotros (971 743 750) e indícanos el problema. Trataremos de solucionarlo lo antes posible.</>
            </Panel>
        </div>
    );
};

class Panel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
        };
    }

    handleToggleCollapsed = () => {
        this.setState({ collapsed: !this.state.collapsed });
    };

    render = () => {
        return (
            <div className={`collapsible-panel-container  ${this.state.collapsed ? '' : 'collapsible-panel-open'}`} onClick={this.state.collapsed ? this.handleToggleCollapsed : undefined}>
                <div className="collapsible-panel-arrow">
                    <IconButton size="medium" onClick={() => this.handleToggleCollapsed()}>
                        {this.state.collapsed === true ? <ArrowDropDownIcon fontSize="large" style={{ color: '#db0030' }} /> : <ArrowDropUpIcon fontSize="large" style={{ color: '#db0030' }} />}
                    </IconButton>
                </div>
                <div className="collapsible-panel-header">{this.props.header}</div>
                <div className="collapsible-panel-body">{this.props.children}</div>
            </div>
        );
    };
}
